import { Box, FormControl, Icons, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import BookingRequestContinueButton from "components/booking-request/booking-request-continue-button";
import { SelectDate } from "components/selection-components/select-date/select-date";
import SelectionHeader from "components/selection-components/selection-header";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";
import { useStepTracking } from "logger/use-step-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { PageType, BookingFeature } from "logger/page-tracking";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { UrlParamName } from "search-params";

export function BookingRequestDate() {
    const { t } = useTranslation();
    const { setDate } = useBookingActionsContext();
    const { date } = useBookingStateContext();

    // OLD SYSTEM: Keep for backward compatibility
    useStepTracking({
        stepName: TrackingStepName.RequestDateStep,
        metadata: {
            hasPreSelectedDate: !!date,
        },
    });

    // NEW SYSTEM: Enhanced tracking with session context
    usePageTracking({
        pageName: "BookingRequestDate",
        pageType: PageType.WizardStep,
        metadata: {
            feature: BookingFeature.Request,
            hasPreSelectedDate: !!date,
            date: date?.format("YYYY-MM-DD"),
        },
    });

    const location = useLocation();
    const experienceIdParam = new URLSearchParams(location.search).get(UrlParamName.EXPERIENCE_ID);
    const experienceId = experienceIdParam ? parseInt(experienceIdParam, 10) : undefined;

    const [localDate, setlocalDate] = useState(date);
    const handleContinue = () => {
        if (!localDate) return;
        setDate?.(localDate?.toDate());
    };

    const handleDateChange = (date?: Date) => {
        setlocalDate(date ? moment(date) : undefined);
    };
    const footerHeight = "104px";
    return (
        <FormControl>
            <SelectionHeader text={t("bookingRequest.date.title")} icon={Icons.Date} />
            <Box
                mb={{
                    base: footerHeight,
                    md: ThemeSpaceVariable.Large,
                }}
            >
                <SelectDate
                    onChange={handleDateChange}
                    date={localDate?.toDate()}
                    bookingRequestMode
                    experienceId={experienceId}
                />
            </Box>
            <BookingRequestContinueButton handleContinue={handleContinue} disabled={!localDate} />
        </FormControl>
    );
}
